
import { Time } from '@angular/common';
import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { GridComponent, DataBindingDirective } from '@progress/kendo-angular-grid';
import * as moment from 'moment';
import { CommonService } from 'src/app/Service/Common.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { PeerReviewService } from 'src/app/Service/peerReview/peer-review.service';
import { IApproveInputModel, IApproveReviewViewModel, DocViewOutput, IReviewListViewModel } from 'src/app/ViewModel/PeerReviewModel';
import { PrInvitationComponent } from "../pr-invitation/pr-invitation.component";
import { ReviewViewComponent } from '../review-view/review-view.component';
import { DocDetailsOutput } from 'src/app/ViewModel/PeerReviewModel';
import { P } from '@angular/cdk/keycodes';


const createFormGroup = (dataItem: { date: any; time_From: any; time_To: any; doc_Location: any; }) => new FormGroup({
  'date': new FormControl(dataItem.date),
  'time_from': new FormControl(dataItem.time_From),
  'time_to': new FormControl(dataItem.time_To),
  'doc_Location': new FormControl(dataItem.doc_Location)
});
@Component({
  selector: 'app-review-approval',
  templateUrl: './review-approval.component.html',
  styleUrls: ['./review-approval.component.css']
})
export class ReviewApprovalComponent implements OnInit {
  public project_Id!: number;
  public memberId!: number;
  public groupId!: number;
  public approveReviewtList: IApproveReviewViewModel[] = [];
  private grid!: GridComponent;
  public Tabname!: string;
  public Feature!: any[];
  public ReviewList!: IReviewListViewModel[];
  public _Data!:any;
  public skip=20;
  public todaydate = new Date(this.getDateFormat());
  @Input() set Data(val:any)
  {
    if(val)
    {
      this._Data = val;
      this.filter();
    }
  } 
  get Data():any
  {
    return this._Data;
  }

  @Output() ReviewListEmitter=new EventEmitter();  
  editedRowIndex:any = null;
  public approveReviewList!: IReviewListViewModel[];
  public isApproved!: string;
  public formGroup!: FormGroup;
  public isDocDateInvalid!: boolean;
  public datevalue = new Date();
  public fromtime!: Time;
  public uptotime!: Time;
  public docLocation!: string;
  public enableFilter : boolean = false;
  public pr_approval: boolean = false;
  public pr_invite_role : boolean = false;
  public pr_invite_feature : boolean = false;
  public PeerECDMEP: boolean = false;
  public sheduleFrom:string;
  public sheduleTo:string;
  Roles: any[];
  @ViewChild(DataBindingDirective) directive!:DataBindingDirective;
  editedDate!: Date;
  constructor(private _peerReviewService: PeerReviewService, private dialog: MatDialog, private _commonService: CommonService,
    private _notificationService: NotificationService) { }
filter()
  {
    if(this._Data){
      this.Tabname = this._Data.tabname;
      this.Feature = this._Data.Feature;
      this.ReviewList =this._Data.ReviewList;
      if (this.directive != undefined)
        this.directive.skip = 0;
      this.skip = 0;
    }
  }
  ngOnInit() {
    this.project_Id = this._commonService.getProjectId();
    this.groupId = this._commonService.getLoggedInUserGroupId();
    this.memberId = this._commonService.getLoggedInUserId();
    this.approveReviewList = this.ReviewList;
    this.pr_approval=this.Feature.some(x => x.feature_Desc=="PR Approval" && x.feature_Id==600002);
    //this.PeerECDMEP=this.Feature.some(x => x.feature_Desc=="ECD" || x.feature_Desc=="MPECD");
    this._commonService.getProjectMemberRoles(this.project_Id,this.groupId,this.memberId).subscribe((res:any[])=>{
      this.Roles = res;
      this.pr_invite_role = this.Roles.some(x=>x.role_Short_Desc.toUpperCase().trim()=='ECD'.toLocaleUpperCase().trim() || x.role_Short_Desc.toUpperCase().trim()=='MECD'.toLocaleUpperCase().trim());
    });  
    this._commonService.getProjectMemberFeatures(this.project_Id, this.memberId, this.groupId).subscribe((res: any[]) => {
      this.pr_invite_feature = res.some(x => x.feature_Desc == "PR Invitation" && x.feature_Id==600003);
    });
  }

  public actionReview(isAction: boolean, dataItem: IReviewListViewModel) {
    this._notificationService.showPopup("Once Approved, No More Action Can be Done? ", 'Confirm').then(data => {
      if (data == 'yes') {
        this.isApproved = isAction == true ? 'Y' : 'N';
        let _input: IApproveInputModel = {
          intUID: this.memberId,
          strDocNumber: dataItem.requestNo,
          dtmScheduledOn: dataItem.date,
          tmScheduledFrom: dataItem.time_From,
          tmScheduledUpto: dataItem.time_To,
          strDocLocation: dataItem.doc_Location,
          chrIsApproved: this.isApproved,
        }
        this._peerReviewService.PostApproveReviewDetails(_input).subscribe((data) => {
          if (data.successCode == 200) {
            this._notificationService.showToast(data.successMessage, "Success");
            this.onClickEmit()
          }
          else {
            this._notificationService.showToast(data.successMessage, "Error");
          }
        });
      }
    });
  }
  public cellClickHandler({ isEdited, dataItem, rowIndex }:any): void {
    if (isEdited) {
      return;
    }
    this.formGroup = createFormGroup(dataItem);
    this.editedRowIndex = rowIndex;
    this.grid.editRow(rowIndex, this.formGroup);
  }

  editRowData({ sender, rowIndex, dataItem }:any) {
    this.sheduleFrom = this.convertTo12HourFormat(dataItem.time_From);
    this.sheduleTo = this.convertTo12HourFormat(dataItem.time_To);
    this.editedDate = new Date(dataItem.date);
    if (this.editedRowIndex >= 0) {
      sender.closeRow(this.editedRowIndex);
    }
    this.editedRowIndex = rowIndex;
    this.formGroup = createFormGroup(dataItem);
    dataItem.is_approve = true;
    sender.editRow(rowIndex);
  }
  cancelRowData({ sender, rowIndex, dataItem }:any) {
    dataItem.is_approve = false;
    sender.closeRow(rowIndex);
  }

  public cancelHandler(): void {
    this.closeEditor();
  }

  private closeEditor(): void {
    this.grid.closeRow(this.editedRowIndex);
    this.editedRowIndex = undefined;
    // this.formGroup = undefined;
  }

  isFromtimeInvalid : boolean = true;
  isTotimeInvalid: boolean = true;
  from_Time!: Time;
  checkfromtime()
  {
    let mintime :Time = {
      hours: 9,
      minutes: 0
    };
    let maxtime :Time = {
      hours: 17,
      minutes: 0
    };
    this.from_Time = this.getFormValue(this.formGroup, 'time_from');
    let fromtime = this.getFormValue(this.formGroup, 'time_from');
    let hr = fromtime.substr(0, 2);
    let min = fromtime.substr(3, 2);
    if(hr >= mintime.hours && hr <= maxtime.hours)
    {
      this.isFromtimeInvalid = false;
      return true;
    }
    else
    {
      this.isFromtimeInvalid = true;
      return false;
    }
    // this.checktotime();
  }



  checktotime()
  {
    let fromtime = this.getFormValue(this.formGroup, 'time_from');
    let from_hr = fromtime.substr(0, 2);
    let from_min = fromtime.substr(3, 2);
    let maxtime :Time = {
      hours: 17,
      minutes: 59
    };
    
    let totime = this.getFormValue(this.formGroup, 'time_to');
    let hr = totime.substr(0, 2);
    let min = totime.substr(3, 2);
    if (hr >= from_hr && hr <= maxtime.hours) 
    {
      if(hr == from_hr)
      {
        if(min > from_min)
        {
          this.isTotimeInvalid = false;
          return true;
        }
        else
        {
          this.isTotimeInvalid = true;
          return false;
        }
      }
      else
      {
        this.isTotimeInvalid = false;
        return true;
      }
    } 
    else
    {
      this.isTotimeInvalid = true;
      return false;
    } 
  }


  fromTimeSelected(time: string,type:string): void {
    if(type == 'shFrom'){
      this.formGroup.get('time_from').setValue(time.trim());
      this.fromtime = this.formGroup.get('time_from').value
    }else {
      this.formGroup.get('time_to').setValue(time.trim());
      this.uptotime = this.formGroup.get('time_to').value
    }
  }

  getDateFormat() {
    let today = new Date();
    var dd = String(today.getDate()).padStart(2, '0');
    var mm = today.toLocaleString('default', { month: 'short' })
    var yyyy = today.getFullYear();
    let today1 = dd + '-' + mm + '-' + yyyy;
    return today1;
  }


  updatescheduledOn(event: any) {
    this.datevalue = event.value;
  }

  public convertTo12HourFormat(time24: string): string {
    const [hours, minutes] = time24.split(':');
  
    let period = 'AM';
    let hours12 = parseInt(hours, 10);
  
    if (hours12 >= 12) {
      period = 'PM';
      if (hours12 > 12) {
        hours12 -= 12;
      }
    }
  
    return `${hours12.toString().padStart(2, '0')}:${minutes} ${period}`;
  }

  // updatescheduledFrom(event: any) {
  //   console.log(this.getFormValue(this.formGroup, 'time_from'));
  //   this.fromtime = this.getFormValue(this.formGroup, 'time_from');
  // }

  // updatescheduledUpto(event: any) {
  //   this.uptotime = this.getFormValue(this.formGroup,'time_to');
  // }
  updateDocumentLocation(event: any) {
    this.docLocation = this.getFormValue(this.formGroup, 'doc_Location');
  }
  UpdateRowData({ sender, rowIndex, dataItem }:any) {
    // if(!this.checkfromtime())
    // {
    //   this._notificationService.showPopup("Select Time above 9:00", "Warning");
    // }
    // else if(!this.checktotime())
    // {
    //   this._notificationService.showPopup("Select Time below 18:00", "Warning");
    // }
    // else
    // {
    let _input: IApproveInputModel = {
      intUID: this.memberId,
      strDocNumber: dataItem.requestNo,
      dtmScheduledOn: !!this.datevalue ? this.datevalue : dataItem.date,
      tmScheduledFrom: !!this.fromtime ? this.fromtime : dataItem.time_From,
      tmScheduledUpto: !!this.uptotime ? this.uptotime : dataItem.time_To,
      strDocLocation: !!this.docLocation ? this.docLocation : dataItem.doc_Location,
      chrIsApproved: null,
    }
    this._peerReviewService.PostApproveReviewDetails(_input).subscribe((data) => {
      if (data.successCode == 200) {
        this._notificationService.showToast(data.successMessage, "Success");
        this.onClickEmit();
      }
      else {
        this._notificationService.showToast(data.successMessage, "Error");
      }
      dataItem.is_approve = false;
    });
    
    sender.closeRow(rowIndex);
  // }
}
  public openInvitation(data: any) {
    let dialogRef = this.dialog.open(PrInvitationComponent, {
      panelClass: 'mat-dialog-primary',
      height: '60',
      maxWidth: '60vw',
      autoFocus: false,
      disableClose: true,
      data: { requestNo: data.requestNo, document_Location: data.document_Location,newReqNo:data.old_Ref_Id }
    });
    dialogRef.afterClosed().subscribe(res => {
      this.onClickEmit();
    })
  }


  viewPeerdoc(dataItem: any) {
    let datainput =
    {
      strDocNumber: dataItem.requestNo,
      intUID: this.memberId
    };
    this._peerReviewService.getPeerDocView(datainput).subscribe((resDoc: DocDetailsOutput) => {
      if (resDoc) {
        let dialogRef = this.dialog.open(ReviewViewComponent,
          {
            panelClass: 'mat-dialog-primary',
            data: { docvalue: resDoc, input: datainput }
          });
        dialogRef.afterClosed().subscribe(res => {
        });
      }
    }, err => { });
  }

  private getFormValue(form: FormGroup, formControlName: string): any {
    return form.get(formControlName)?.value;
  }

  isinvite(dataItem: IReviewListViewModel): boolean {
    if (dataItem.ds_code == 2 && this.Tabname != 'Approval')
      return true;
    else return false
  }

  toggleFilter() {
    this.enableFilter = !this.enableFilter;
  }
  public onClickEmit() {
    this.ReviewListEmitter.emit(true);
  }
}
